import { Rows } from "../../../interfaces";
import { MetricPortfolioAnalysisWrapperCompany, MetricPortfolioAnalysisWrapperEntryDTO } from "src/app/domain/kpi/dto/MetricPortfolioAnalysis";
import { centerNoBold, kpiHeaders, kpiPortfolioAnalysisFirsRowGreen, kpiPortfolioAnalysisFirsRowOrange, left } from "src/app/util/excelStyles";
import { dashInsteadOfNullCommon, formats, getCell, withCellStyles } from "../../../utils";
import { MetricDataRole } from "src/app/domain/kpi/dto/MetricData";
import {
  MetricPortfolioAnalysisWrapperCompanyExportExcel,
} from "../../../../kpi/components/kpi-metrics-main/portfolio-analysis/kpi-portfolio-analysis.component";

export const getPreparedData = (data: MetricPortfolioAnalysisWrapperCompanyExportExcel): Rows => {
  const newData: Rows = [];
  newData.push(generateFirstRow(data.headers));
  const headers = data.headers.map((h) => (h.metricGroupName + ' \n ' + h.metricName));
  const designedHeaderRow = generateDesignedHeaderRow();
  headers.forEach((header) => designedHeaderRow.push(withCellStyles(header, kpiHeaders)));
  const headersForLogic = ['Company', 'Provided date', null].concat(headers);
  newData.push(designedHeaderRow);
  const mainRows = getMainRows(data.data.companies, data.headers, headersForLogic);
  newData.push(...mainRows);
  return newData;
};

const generateDesignedHeaderRow = (): any[] => {
  const designedHeaderRow: any[] = [];
  designedHeaderRow.push(withCellStyles('Company', kpiHeaders));
  designedHeaderRow.push(withCellStyles('Provided date', kpiHeaders));
  designedHeaderRow.push(withCellStyles(null, kpiHeaders));
  return designedHeaderRow;
};

const getMainRows = (companies: MetricPortfolioAnalysisWrapperCompany[], headersForLogic: MetricPortfolioAnalysisWrapperEntryDTO[], designedHeaderRow: string[]): Rows => {
  const rows: Rows = [];
  const mappedToHeaders = companies.map((c) => getNewMapping(c, headersForLogic, designedHeaderRow));
  for (const mapped of mappedToHeaders) {
    const row = [];
    for (const header of designedHeaderRow) {
      if (header === 'Company') {
        row.push(withCellStyles(mapped[header], left));
      } else {
        row.push(withCellStyles(mapped[header], centerNoBold));
      }
    }
    rows.push(row);
  }
  return rows;
};

const getNewMapping = (company: MetricPortfolioAnalysisWrapperCompany, headers: MetricPortfolioAnalysisWrapperEntryDTO[], designedHeaderRow: string[]): object => {
  const dateProvided = company.entries.filter((c) => c.period.provided);
  const body = {
    Company: company.company.name,
    null: null,
    'Provided date': dateProvided.length ? dateProvided[0].period.provided : '',
  };
  let mappingHeaders = [...designedHeaderRow];
  mappingHeaders = prepareMappingHeadersForBody(mappingHeaders);
  mappingHeaders.forEach((h, i) => {
    body[h] = getCell({
      v: dashInsteadOfNullCommon(company.entries[i].data.rawValue),
      z: formats.thousandsSeparator,
      t: 'n',
    });
  });
  return body;
};

const prepareMappingHeadersForBody = (mappingHeaders: string[]): string[] => {
  mappingHeaders.shift();
  mappingHeaders.shift();
  mappingHeaders.shift();
  return mappingHeaders;
};

const generateFirstRow = (headers: MetricPortfolioAnalysisWrapperEntryDTO[]): any[] => {
  const firstRow: any[] = [];
  firstRow.push(withCellStyles('', null));
  firstRow.push(withCellStyles('', null));
  firstRow.push(null);
  headers.forEach((h) => firstRow.push(withCellStyles(h.role + ' ' + h.period.expected, h.role === MetricDataRole.ACTUAL ? kpiPortfolioAnalysisFirsRowGreen : kpiPortfolioAnalysisFirsRowOrange)));
  return firstRow;
};
